import { api } from '../../../../api/datasource'
import CustomStore from 'devextreme/data/custom_store'

const baseURL = "/financeiro/documento_grupo_produto_servico/"

export const onRowInsertingUpdating = (e, dataCadastro) => {
    const data = e.data || e.newData;
  
    const produtoFoiAlterado = data?.cad_produto_servico_id !== undefined;
    const unidadeNaoPreenchida = !data?.cad_unidade_medida_id;
  
    if (produtoFoiAlterado && unidadeNaoPreenchida) {
      const produto = dataCadastro.produto_servico.find(
        (p) => p.id === data.cad_produto_servico_id
      );
      if (produto?.cad_unidade_medida_id) {
        data.cad_unidade_medida_id = produto.cad_unidade_medida_id;
      }
    }
  };


export const dataSource = (grupoId) => {
    const apiURL = baseURL + grupoId

    return new CustomStore({
        key: 'id',

        load: async (options) => {
            const res = await api.get(apiURL)
            // console.log(res)
            return res
        },
        insert: async (values) => {           

            values.fin_documento_grupo_id = grupoId
            const res = await api.post(apiURL, values)
            // res.data.instance
            return await res.data.instance
        },

        update: async (obj, values) => {
            const res = await api.put(apiURL, obj, values)
            return res.data
        },

        remove: async (key) => {
            await api.delete(apiURL + '/' + key)
        },

    })

}